import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

export const useGetPickemByIdQuery = (id: string | undefined) => {
  return useQuery({
    queryKey: queryKeys.pickems.detail(id || ''),
    queryFn: () => apiClient.get('/api/admin/pickems/{id}', { pathParams: { id: id! } }),
    enabled: !!id,
    select: data => data?.pickem,
  });
};
